import { MemberAllowedResourcesLookup } from '../enums/member-allowed-resources.enum';

export class MemberResourcesConstants {
    public static memberAllowedResources = [{
        id: MemberAllowedResourcesLookup.DashBoard,
        resourceUrl: '/account/dashboard',
        icon: 'fa fa-tachometer'
    }, {
        id: MemberAllowedResourcesLookup.MyProfile,
        resourceUrl: '/account/my-profile',
        icon: 'fa fa-cog'
    }, {
        id: MemberAllowedResourcesLookup.OrderHistory,
        resourceUrl: '/account/order-history',
        icon: 'order-icon-font fa fa-shopping-bag'
    }, {
        id: MemberAllowedResourcesLookup.Autoship,
        resourceUrl: '/account/autoship-preferences',
        icon: 'order-icon-font fa fa-shopping-bag'
    },
    // {
    //     id: MemberAllowedResourcesLookup.CCSnapshot,
    //     resourceUrl: '/account/cc-snapshot',
    //     icon: 'address-icon-font fa fa-creative-commons'
    // },
    {
        id: MemberAllowedResourcesLookup.SavedPayments,
        resourceUrl: '/account/payment-methods',
        icon: 'address-icon-font fa fa-credit-card'
    }, {
        id: MemberAllowedResourcesLookup.SavedAddresses,
        resourceUrl: '/account/addresses',
        icon: 'address-icon-font fa fa-address-card'
    }, {
        id: MemberAllowedResourcesLookup.Password,
        resourceUrl: '/account/security-preferences',
        icon: 'fa fa-shield'
    }, {
        id: MemberAllowedResourcesLookup.MyActionCenter,
        resourceUrl: '/account/actioncenter',
        icon: 'fa fa-shield'
    }, {
        id: MemberAllowedResourcesLookup.CommunicationPreferences,
        resourceUrl: '/account/communication-preferences',
        icon: 'order-icon-font fa fa-comments-o'
    }, {
        id: MemberAllowedResourcesLookup.MyReviews,
        resourceUrl: '/account/myreviews',
        icon: 'address-icon-font fa fa-sticky-note-o'
    },
    // {
    //     id: MemberAllowedResourcesLookup.MyStore,
    //     resourceUrl: '/account/my-store',
    //     icon: 'address-icon-font fa fa-sticky-note-o'
    // },
    {
        id: MemberAllowedResourcesLookup.ForeverBusinessOwnerSetup,
        resourceUrl: '/account/fbosetup',
        icon: 'address-icon-font fa fa-bell-o'
    }];
}
